import star1Img from '@/assets/images/Star1_1776849802227-CC9yuZja.png';
import star5Img from '@/assets/images/Star5_1776849802227-B5ZP0PBQ.png';
import striderImg from '@/assets/images/Strider_Jumping_1776849761236-9bxvnvyH.png';

export const STRIDER_SRC = striderImg;

export const STAR_SRC: Record<1 | 2, string> = {
  1: star1Img,
  2: star5Img,
};

const PRELOAD_SRCS = [striderImg, star1Img, star5Img] as const;

let imagesReadyPromise: Promise<void> | null = null;

function loadAndDecodeImage(src: string): Promise<void> {
  const img = new Image();
  img.src = src;
  return img.decode().catch(() => {
    if (img.complete && img.naturalWidth > 0) return;
    return new Promise<void>((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = () => reject(new Error(`Failed to load completion celebration image: ${src}`));
    });
  });
}

/**
 * Load and decode completion overlay bitmaps so injected `<img>` nodes paint immediately
 * (avoids alt-text flash and late-pop-in during CSS motion).
 */
export function preloadCompletionCelebrationImages(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (!imagesReadyPromise) {
    imagesReadyPromise = Promise.all(PRELOAD_SRCS.map(loadAndDecodeImage)).then(() => undefined);
  }
  return imagesReadyPromise;
}

/** Same as {@link preloadCompletionCelebrationImages}; use before opening the overlay. */
export function getCompletionCelebrationImagesReady(): Promise<void> {
  return preloadCompletionCelebrationImages();
}
